'use client'

import { useEffect } from 'react'

import { LOGOUT_CLIENT_TEST_IDS } from '@common/common-test-ids.const'
import { AUTH_LOGOUT_PATH } from '@common/core.const'

import { useSessionStore } from '@stores/session/session.store'

import styles from './LogoutClient.module.scss'

export function LogoutClient() {
  // Effects
  useEffect(() => {
    // Clear session token on logout
    useSessionStore.getState().clearToken()
    window.location.href = AUTH_LOGOUT_PATH
  }, [])

  return (
    <div className={styles.container} data-testid={LOGOUT_CLIENT_TEST_IDS.root}>
      <div className={styles.content}>
        <h1>Signing out...</h1>
        <p>You are being redirected to the login page.</p>
      </div>
    </div>
  )
}
